import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import type { CommonProps } from '../../types';
import { type ContainerProps, Container, Heading, VipHeading } from '../../';

export interface HeadingLayoutProps
    extends CommonProps,
        VariantProps<typeof HeadingLayoutStyles>,
        Pick<ContainerProps, 'maxWidth'> {
    title?: string;
    children?: ReactNode;
    layout?: 'default' | 'mainBrand' | 'vip';
    invertFontColor?: boolean;
}

export const HeadingLayoutStyles = cva('', {
    variants: { isVIP: { true: 'selection-ba' } },
    defaultVariants: { isVIP: false },
});

export const HeadingLayout = ({
    className,
    title,
    children,
    testId = 'heading-layout',
    maxWidth = 'xl',
    invertFontColor = false,
    isVIP,
    ...props
}: HeadingLayoutProps): JSX.Element => {
    return (
        <div
            className={twMerge(HeadingLayoutStyles({ isVIP, className }))}
            {...props}
            data-testid={testId}
        >
            <Container maxWidth={maxWidth}>
                {isVIP ? (
                    <VipHeading
                        invertFontColor={invertFontColor}
                        title={title}
                    />
                ) : (
                    <Heading
                        size="h1"
                        className="mb-2 font-normal md:mb-8 xl:ml-0"
                    >
                        {title}
                    </Heading>
                )}
                {children}
            </Container>
        </div>
    );
};
